import React from 'react';
import GreenButton from './misc/GreenButton';
import '../assets/css/resultsform.css';

const ResultsForm = (props) => {
  return (
    <div className="popup">
      <div className="info-popup">
        <h2 className="align-center dat-grey">Get Unique Code To See Your Results</h2>
        <button onClick={props.closeEmailPopup} className="close-button">×</button>
        <input type="email" id="email" pattern=".+@globex.com" className="email" onChange={props.handleChange('email')} placeholder="Please enter your email" />
        {props.invalidEmail ?
          <label className="invalid-email">Please enter a valid email!</label>
          :
          null
        }
        <div className="place-button">
          <GreenButton continue={props.POST_ACTION} name="GET YOUR RESULTS" />
        </div>
        <img alt="grey-snake" className="popup-pic marginTop" src={require("../assets/imgs/grey-snake.png")} />
        <div className="send-again">
          <span className="">Didn't receive your e-mail? </span>
          <a className="blue-color link" href="http://web.wholechildapp.com">Send Again</a>
        </div>
      </div>
    </div>
  )
}

export default ResultsForm
